var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{class:[
      'skill-tabs',
      _vm.goalkeeperMode ? 'goalkeeper-tabs' : 'player-tabs' ],attrs:{"card":""}},_vm._l((_vm.categories),function(category,i){return _c('b-tab',{key:i,attrs:{"title":category.name,"active":i === 0}},[_c('skills',{attrs:{"skills":category.skills}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }